<template>
  <dialog-reset height="75vh" top="5vh" width="80%" title="选择翻车机作业记录" :visible.sync="visible">
    <div>
      <avue-crud v-if="visible" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :permission="permissionList" :before-open="beforeOpen" v-model="form" ref="crud" @row-update="rowUpdate" @row-save="rowSave"
        @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange" @row-dblclick="rowDblClick"
        @on-load="onLoad">
      </avue-crud>
    </div>
  </dialog-reset>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getWagonOperationPlanPage } from "../api";

export default {
  mixins: [crudMixins],
  name: 'SelectWagonOperationPlanList',
  data () {
    return {
      apiConfig: { getList: getWagonOperationPlanPage },
      defaultParams: {},
      visible: false,
      query: {},
      option: {
        cancelHijack: true,
        maxHeight: '380',
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        menu: false,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchLabelWidth: 90,
        indexLabel: '序号',
        align: 'center',
        labelWidth: 135,
        column: [
          {
            label: '计划日期',
            prop: 'planDate',
            type: 'date',
            search: true,
          },
          {
            label: '计划翻卸车数',
            prop: 'plannedVehicles',
            search: false,
          },
          {
            label: '计划作业时长(小时)',
            prop: 'plannedHours',
          },
          {
            label: '实际翻卸车数',
            prop: 'actualVehicles',
            search: false,
          },
          {
            label: '实际作业时长(分钟)',
            prop: 'actualHours',
            search: false,
          },
          {
            label: '完成率(%)',
            prop: 'completionRate',
            search: false,
          },
          {
            label: '滞后车数',
            prop: 'lagCount',
            search: false,
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
    }
  },
  created () { },
  methods: {
    open () {
      this.visible = true
    },
    // 双击行选择
    rowDblClick (item) {
      this.$emit('replace', item)
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: none;
}
</style>
